export default "__VITE_ASSET__DvjZ4QuA__"